import React from 'react';
import styled from 'styled-components';

const CtaContainer = styled.section`
  background: #25aae3;
  padding: 40px 8%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
    gap: 20px;
  }
`;

const CtaText = styled.h2`
  color: #ffffff;
  font-family: 'Open Sans', sans-serif;
  font-size: 28px;
  font-weight: 600;
  margin: 0;
`;

const CtaButton = styled.button`
  background: #ffffff;
  color: #25aae3;
  border: none;
  padding: 14px 28px;
  font-size: 14px;
  font-family: 'Montserrat', sans-serif;
  font-weight: bold;
  border-radius: 50px;
  cursor: pointer;
  box-shadow: 0 4px 14px rgba(0,0,0,0.1);
  transition: transform 0.2s;

  &:hover {
    transform: translateY(-2px);
  }
`;

const CTA = () => {
  return (
    <CtaContainer>
      <CtaText>Ready To Gain Real Followers?</CtaText>
      <CtaButton>SIGN UP TODAY</CtaButton>
    </CtaContainer>
  );
};

export default CTA;
